import { ORGANIZATION_STATUS, OrganizationStatusType } from '@/bundle/_Opco/types/types';
import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';

export const STATUS_MAP: StatusType = {
  [ORGANIZATION_STATUS.ACTIVE]: { title: 'Active', variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [ORGANIZATION_STATUS.BLOCKED]: { title: 'Blocked', variant: STATUS_VARIANT_HIGHLIGHT.GREY },
};

type OrganizationStatusPropsType = {
  status: OrganizationStatusType;
};

export const OrganizationStatus = ({ status }: OrganizationStatusPropsType) => {
  const statusMap = STATUS_MAP[status];

  return <StatusWrapper variant={statusMap?.variant}>{statusMap?.title}</StatusWrapper>;
};
